import { ref, uploadString, getDownloadURL } from "firebase/storage";
import { doc, updateDoc, serverTimestamp } from "../access/firestore";
import { storage, db, auth } from "../firebase";
export async function saveEvolutionSignature(clinicId, appointment, dataUrl) {
  const patientId =
    appointment.pacienteId || appointment.patientId || appointment.idPaciente;
  if (
    ![clinicId, patientId, appointment.id].every(
      (value) => typeof value === "string" && /^[\w-]{1,128}$/.test(value),
    )
  )
    throw new Error(
      "La evolución debe estar vinculada a un paciente antes de firmarla.",
    );
  const uid = auth.currentUser?.uid;
  if (!uid) throw new Error("Inicia sesión nuevamente para guardar la firma.");
  if (appointment.firmaURL || appointment.firmadaAt || appointment.firmadaPor)
    throw new Error("Esta evolución ya está firmada.");
  const path = `clinics/${clinicId}/pacientes/${patientId}/evolucion/${appointment.id}/firmas/${crypto.randomUUID()}.png`;
  const target = ref(storage, path);
  await uploadString(target, dataUrl, "data_url", { contentType: "image/png" });
  const url = await getDownloadURL(target);
  if (auth.currentUser?.uid !== uid)
    throw new Error("Tu sesión cambió antes de guardar la firma.");
  await updateDoc(doc(db, "clinics", clinicId, "citas", appointment.id), {
    firmaURL: url,
    firmaPath: path,
    firmadaAt: serverTimestamp(),
    firmadaPor: uid,
  });
  return { url, path };
}
export function signatureErrorMessage(error) {
  if (
    [
      "storage/unauthorized",
      "permission-denied",
      "functions/permission-denied",
    ].includes(error?.code)
  )
    return "No se pudo autorizar la firma. Revisa con la administración tu acceso a Evolución y al paciente. Tus trazos siguen en pantalla para reintentar.";
  return "No se pudo guardar la firma. Tus trazos siguen en pantalla; revisa tu conexión y vuelve a intentarlo.";
}
